import React, { useCallback, useEffect, useState } from 'react';
import { useAuth } from '@/context/AuthContext';

const API = process.env.REACT_APP_BACKEND_URL;

export function EmailStatusPanel() {
  const { token } = useAuth();
  const [s, setS] = useState(null);
  const [test, setTest] = useState(null);
  const [busy, setBusy] = useState(false);
  const auth = { Authorization: `Bearer ${token}` };
  const load = useCallback(async () => {
    const res = await fetch(`${API}/api/admin/email-status`, { headers: { Authorization: `Bearer ${token}` } });
    if (res.ok) setS(await res.json());
  }, [token]);
  useEffect(() => { load(); }, [load]);
  const runTest = async () => {
    setBusy(true);
    const res = await fetch(`${API}/api/admin/email-status/test`, { method: 'POST', headers: auth });
    setTest(res.ok ? await res.json() : { ok: false, reason: 'Could not run the test.' });
    setBusy(false);
    load();
  };
  if (!s) return null;
  const last = s.last_attempt;
  return (
    <div className="rounded-2xl border border-white/10 bg-white/[0.02] p-5 space-y-2 text-sm" data-testid="email-status-panel">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <h3 className="font-semibold">Email status</h3>
        <button type="button" onClick={runTest} disabled={busy} className="rounded-full border border-amber-400/50 px-3 py-1 text-xs text-amber-200 hover:bg-white/5 disabled:opacity-40" data-testid="email-status-test-btn">{busy ? 'Sending...' : 'Send test email'}</button>
      </div>
      <p className="text-gray-400" data-testid="email-status-config">Resend key: {s.key_set ? 'set' : 'missing'} | From: {s.mail_from || 'missing'} | To: {s.recipients.join(', ') || 'missing'}</p>
      {last && <p className={last.ok ? 'text-emerald-300' : 'text-red-300'} data-testid="email-status-last">Last send: {last.ok ? 'OK' : 'Failed'}. {last.reason}</p>}
      {test && <p className={test.ok ? 'text-emerald-300' : 'text-red-300'} data-testid="email-status-test-result">Test: {test.reason}</p>}
    </div>
  );
}
